'use client';
import React from 'react';
import { Box, Stack } from '@mui/material';
import ParallaxText from '@components/ParallaxText';
import ReactHtmlParser from '@libs/reactHtmlParser';
import CommonContainer from '@components/CommonContainer';
import CustomImage from '@components/CustomImage';
import WorldAldarNavigation from '@components/WorldAldarNavigation';

import cn from './style.module.scss';

export default function WharfWelcome(props: any) {
  return (
    <Stack
      component="section"
      className={cn.wharfWelcomeWrapper}
      id="wharfAboutID"
    >
      <Box className={cn.wharfWelcomeInner}>
        <CommonContainer maxWidth={{ xs: '100%', md: '1320px' }} flexGrow={1}>
          <Box className={cn.wharfWelcomeBlock}>
            <Box className={cn.wharfWelcomeWorld}>
              <WorldAldarNavigation
                data={props.locale.section['ransomBannerAboutWorldOfAldar']}
                classNames={{
                  wrapper: cn.wharfWelcomeWorldWrapper,
                  icon: cn.wharfWelcomeWorldIcon,
                  data: cn.wharfWelcomeWorldData,
                  button: cn.wharfWelcomeWorldButton,
                }}
              />
            </Box>
            <Box className={cn.wharfWelcomeContent}>
              <Box className={cn.wharfWelcomeContent__heading}>
                <ParallaxText
                  variant="h2"
                  animationType="zoomIn"
                  animationDuration={500}
                >
                  {ReactHtmlParser(
                    props.locale.section['ransomIntroductionHeading']
                  )}
                </ParallaxText>
              </Box>
              <Box className={cn.wharfWelcomeContent__data}>
                <ParallaxText
                  variant="p"
                  animationType="zoomIn"
                  animationDuration={500}
                >
                  {ReactHtmlParser(
                    props.locale.section['ransomIntroductionContent']
                  )}
                </ParallaxText>
              </Box>
              <Box className={cn.wharfWelcomeContent__power}>
                <Box className={cn.wharfPowerLabel}>
                  <ParallaxText
                    variant="p"
                    animationType="zoomIn"
                    animationDuration={500}
                  >
                    {ReactHtmlParser(
                      props.locale.section['ransomIntroductionPowered']
                    )}
                  </ParallaxText>
                </Box>
                <Box className={cn.wharfPowerLogo}>
                  <CustomImage
                    src={props.images.ransome_wharf_lsq_logo_dark?.src || ''}
                    alt={'BrookGreen Introduction Image'}
                    width={768}
                    height={768}
                  />
                </Box>
              </Box>
            </Box>
          </Box>
        </CommonContainer>
      </Box>
    </Stack>
  );
}
